import React from "react";
import { useTranslation } from "react-i18next";
import DashboardHeader from "../../../../../components/dashboard/dashboardHeader";
import { ChecklistsList } from "../../../quality/checklists/list";

/**
 * HSE/KS Checklists List - Sjekklister (ISO 9001:2015 kap. 8.5)
 * Wrapper around existing ChecklistsList with HSE/KS context
 */
export const HseKsChecklistsList = () => {
  const { t } = useTranslation();

  return (

 <ChecklistsList />

  );
};

